// File: config.base.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items used throughout the application.
// Other Contributors:

import { internalUrls } from './config.internalUrls';

const domain = document.domain;

const CGP_LOGIN_TEST = 'https://mfg-gateway.tst.gm.com/pcfsso?RelayState=';

export const cgpLoginUrls = internalUrls.includes(domain) ?
   {
      'LOCAL': CGP_LOGIN_TEST,
      'DEV': CGP_LOGIN_TEST,
      'QA': CGP_LOGIN_TEST,
      'TEST': CGP_LOGIN_TEST,
      'PROD': 'https:///mfg-gateway.gm.com/authn/authn/?RelayState='
   } :
   {
      'DEV': 'https://mfg-gateway.tst.gm.com/authn/authn/?RelayState=',
      'QA': 'https://mfg-gateway-qa.gm.com/authn/authn/?RelayState=',
      'TEST': 'https://mfg-gateway.tst.gm.com/authn/authn/?RelayState=',
      'PROD': 'https://mfg-gateway.gm.com/authn/authn/?RelayState='
   };

   
const CGP_SECURITY_TEST = 'https://mfg-gateway.tst.gm.com/authn/token/';
export const cgpSecurityUrls = internalUrls.includes(domain) ?
   {
      'LOCAL': CGP_SECURITY_TEST,
      'DEV': CGP_SECURITY_TEST,
      'QA': CGP_SECURITY_TEST,
      'TEST': CGP_SECURITY_TEST,
      'PROD': 'https:///mfg-gateway.gm.com/authn/authn/token/'
   } :
   {
      'DEV': 'https://mfg-gateway.tst.gm.com/authn/authn/token/',
      'QA': 'https://mfg-gateway-qa.gm.com/authn/authn/token/',
      'TEST': 'https://mfg-gateway.tst.gm.com/authn/authn/token/',
      'PROD': 'https:///mfg-gateway.gm.com/authn/authn/token/'
   };

export const baseConfig = {
   appInfo: {
      name: 'Tool Progress Reporting / Engineering Change Management',
      version: '2',
      company: 'GENERAL MOTORS'
   },
   baseUrl: '',
   authentication: {
      authenticationCookie: 'Authorization',
      authenticationType: 'Bearer',
      userInfoCookie: 'UserInfo'
   }
};

